<div class="file-viewer-dialog-main-container">
    <file-viewer [viewerDto]="viewerData" (onClose)="close()"></file-viewer>
</div>